/** The Vue d'ensemble palette — shared so every card names an axis in the same hue. */
export const COLORS = {
  geo: '#7C3AED',
  narrative: '#7C3AED',
  authority: '#0E9F6E',
  referral: '#EA580C',
  earnedMedia: '#0EA5E9',
  comparison: '#1d4ed8',
  up: '#10B981',
  down: '#EF4444',
};
